import { ErrorBar } from "components/Alert/ErrorBar";
import { SuccessBar } from "components/Alert/SuccessBar";
import { Loader } from "components/Loaders/Loader";
import { createContext, useContext, useState } from "react";

const isMobileScreen = () => {
  const width = window.innerWidth;
  return width < 768;
};

const GlobalContext = createContext({
  error: null,
  setError: () => {},
  success: null,
  setSuccess: () => {},
  isLoading: false,
  setIsLoading: () => {},
  isInitializing: false,
  setIsInitializing: () => {},
  pageAccess: {
    canRead: false,
    canWrite: false,
    canApproval: false,
    canAdmin: false,
    canViewAll: false,
  },
  setPageAccess: () => {},
  isMobile: isMobileScreen(),
  copy: {},
  setCopy: () => {},
  unBoundMode: false,
  setUnBoundMode: () => {},
});

export const GlobalProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);
  const [pageAccess, setPageAccess] = useState({
    canRead: false,
    canWrite: false,
    canApproval: false,
    canAdmin: false,
    canViewAll: false,
  });
  const [isMobile, setIsMobile] = useState(isMobileScreen());
  const [copy, setCopy] = useState(undefined);
  const [unBoundMode, setUnBoundMode] = useState(true);
  return (
    <GlobalContext.Provider
      value={{
        error,
        setError,
        success,
        setSuccess,
        isLoading,
        setIsLoading,
        isInitializing,
        setIsInitializing,
        isMobile,
        pageAccess,
        setPageAccess,
        copy,
        setCopy,
        unBoundMode,
        setUnBoundMode,
      }}
    >
      <>
        {isInitializing && <Loader />}
        {isLoading && <Loader />}
        {success && <SuccessBar message={success} resetSuccess={setSuccess} />}
        {error && <ErrorBar message={error} resetError={setError} />}
        {children}
      </>
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};
